<button
	(click)="openInDt($event)"
	mat-icon-button
	class="open-dt-button"
	[disabled]="!isButtonEnabled()"
	[title]="
		isButtonEnabled()
			? ('show_in_digital_twin' | translate)
			: (disabledToolTip() | translate)
	"
>
	<mat-icon svgIcon="digital-twin"></mat-icon>
</button>
